import React, { useContext, useMemo } from "react";
import { useHistory } from "react-router-dom";
import * as rightsCodes from "constants/rightsCodes";
import HeaderPortal from "components/layout/HeaderPortal";
import HeaderLinks from "./HeaderLinks";
import PartnerListBrowser from "./PartnerListBrowser";
import BankListBrowser from "./BankListBrowser";
import SelfPartnerListBrowser from "./SelfPartnerListBrowser";
import useLocator from "hooks/useLocator";
import { RightsContext } from "providers/RightsContext";
import { hasAuthorization } from "utils/functions";

const List = () => {
  const { isBank, isSelfPartner, path } = useLocator();
  const history = useHistory();
  const rights = useContext(RightsContext);

  const showPartnerListBroswer = useMemo(() => {
    return !isBank && !isSelfPartner && hasAuthorization(rightsCodes.MASTER_PARTNER_READ, rights);
  }, [isBank, isSelfPartner, rights]);
  const showBanksListBroswer = useMemo(() => {
    return isBank && hasAuthorization(rightsCodes.MASTER_PARTNER_BANKS_READ, rights);
  }, [isBank, rights]);
  const showSelfPartnerListBroswer = useMemo(() => {
    return isSelfPartner && hasAuthorization(rightsCodes.MASTER_PARTNER_SELFPARTNER_READ, rights);
  }, [isSelfPartner, rights]);

  const handleAdd = () => {
    history.push(`/${path}/new`);
  };

  return (
    <>
      <HeaderPortal inEdit={false}>
        <HeaderLinks onAdd={handleAdd}></HeaderLinks>
      </HeaderPortal>
      {showPartnerListBroswer && <PartnerListBrowser />}
      {showBanksListBroswer && <BankListBrowser />}
      {showSelfPartnerListBroswer && <SelfPartnerListBrowser />}
    </>
  );
};

export default List;
